import React from "react";

import type { Job } from "./jobTypes";

const JobList = React.lazy(() => import("./JobList"));
const JobShow = React.lazy(() => import("./JobShow"));

export default {
  list: JobList,
  show: JobShow,
  recordRepresentation: (record: Job) =>
    [record.code, record.customer_name].filter(Boolean).join(" · "),
};
